// CustomExtendAlert.js
import React from 'react';

const CustomExtendAlert = ({ isOpen, message, onYes, onNo }) => {
  if (!isOpen) return null;

  return (
    <div className="custom-alert-overlay">
      <div className="custom-alert">
        <p className="customAlert-message">{message}</p>

        <button className="extendAlert_yes buttonStyle" onClick={onYes}>延長</button>
        <button className="extendAlert_no buttonStyle" onClick={onNo}>いいえ</button>
      </div>
    </div>
  );
};

export default CustomExtendAlert;
